import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { CRUMB_LABEL_KEY as crumbLabel, NAME as name } from '../constants';
import { apiProvider } from '../api';

const edit = {
	JobId: null as number | null,
	PracovnikId: null as number | null,
	LastDate: null as Date | null,
	NextDate: null as Date | null,
	Interval: null as number | null,
	What: null as string | null,
	Flag: null as number | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel,
	dropdownList: {
		PracovnikId: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	extraGetters: {},
	extraMutations: {},
	extraActions: {},
	localState: {},
	props: {
		mode: null,
	},
});
